module.exports = __webpack_public_path__ + "static/img/ARAD4_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD4_1.png
// module id = T3fw
// module chunks = 0